// extracted by mini-css-extract-plugin
module.exports = {"multioption":"RecipientsAndContentFormItems_multioption__1w6lp"};